import { UnreachableFunction } from 'ui/base/types';
import { Theme, ThemedStyles } from 'ui/base/theme';

import Messages from './seen_messages';
import baseStyles from './seen.module.css';

import seenIconImageSeenDaylight from './seen_icons/seen/light.png';
import seenIconImageSeenMidnight from './seen_icons/seen/dark.png';
import seenIconImageUnseenDaylight from './seen_icons/unseen/light.png';
import seenIconImageUnseenMidnight from './seen_icons/unseen/dark.png';

export enum Seen {
  SEEN = 'seen',
  UNSEEN = 'unseen',
}

export const seenSymbolsMap = new Map<Seen, string>([
  [Seen.SEEN, '\u2713\uFE0E'],
  [Seen.UNSEEN, '\u26A0\uFE0E'],
]);

export const castSeenFromBooleanMap = new Map<boolean, Seen>([
  [true, Seen.SEEN],
  [false, Seen.UNSEEN],
]);

export function fromBoolean(seen: boolean) {
  return castSeenFromBooleanMap.get(seen) ?? null;
}

export const ORDERED_SEEN: readonly Seen[] = [
  Seen.SEEN,
  Seen.UNSEEN,
];

export function getFullSeen(seen: Seen|null) {
  return `${getMicroSeen(seen)} ${getShortSeen(seen)}`;
}

export function getShortSeen(seen: Seen|null) {
  switch(seen) {
    case Seen.SEEN:
      return Messages.seen();
    case Seen.UNSEEN:
      return Messages.new();
    default:
      return Messages.unknown();
  }
}

export function getMicroSeen(seen: Seen|null) {
  return (seen !== null ? seenSymbolsMap.get(seen) : null) ?? '?';
}

export type SeenIconStyles = {
  seen: string;
  unseen: string;
};

export const themedSeenIconClassStyles: ThemedStyles<SeenIconStyles> = {
  [Theme.DAYLIGHT]: {
    seen: baseStyles.seenIconClassSeenDaylight,
    unseen: baseStyles.seenIconClassUnseenDaylight,
  },
  [Theme.MIDNIGHT]: {
    seen: baseStyles.seenIconClassSeenMidnight,
    unseen: baseStyles.seenIconClassUnseenMidnight,
  },
};

export const themedSeenIconImageStyles: ThemedStyles<SeenIconStyles> = {
  [Theme.DAYLIGHT]: {
    seen: seenIconImageSeenDaylight,
    unseen: seenIconImageUnseenDaylight,
  },
  [Theme.MIDNIGHT]: {
    seen: seenIconImageSeenMidnight,
    unseen: seenIconImageUnseenMidnight,
  },
};

export const getSeenIcon = (styles: SeenIconStyles, seen: Seen): string => {
  switch(seen) {
    case Seen.SEEN:
      return styles.seen;
    case Seen.UNSEEN:
      return styles.unseen;
    default:
      return UnreachableFunction(seen);
  }
};
